import { useState } from "react";
import styles from "./Dial.module.scss";
import DialIcon from "components/UI/Icons/Sidecar/Dial";
import DeleteIcon from "components/UI/Icons/Delete";
import EditIcon from "components/UI/Icons/Lines/Edit";
import { useDispatch } from "react-redux";
import { removeSidecarConfigNewTempActionList, setShowDialDialogue } from "redux/sidecar/sidecarSlice";
import MoveUpDown from "components/UI/Icons/Sidecar/MoveUpDown";

const DialActionCard = ({uuid, extension, drag, changesMade}:{uuid:string, extension:string, drag?:any, changesMade:()=>void}) => {
	const [editHover, setEditHover] = useState(false);
	const [deleteHover, setDeleteHover] = useState(false);
	const dispatch = useDispatch();
	return (
		<div className={styles.card} draggable onDragEnd={drag?.handlesort}  onDragEnter={()=>{drag?.dragEnter(drag)}} onDragStart={()=>{drag?.dragStart(drag)}}> 
			<p>
				{drag && <MoveUpDown />}
				<DialIcon />
				<span>Dials</span>
			</p>
			<p>
				<span className={styles.extension}>{extension}</span>
				{uuid &&
				<>
					<span className={styles.actionButton} onClick={()=>{changesMade(); dispatch(setShowDialDialogue({uuid:`${uuid}`, show:true, numberValue:`${extension}`}))}} onMouseOver={() => {setEditHover(true);}} onMouseOut={() => {setEditHover(false);}}><EditIcon color={editHover?"primary-default" : "icon-primary"}/></span>
					<span className={styles.actionButton} onClick={()=>{changesMade(); dispatch(removeSidecarConfigNewTempActionList(uuid))}} onMouseOver={() => {setDeleteHover(true);}} onMouseOut={() => {setDeleteHover(false);}}><DeleteIcon color={deleteHover?"support-danger-default" : "icon-primary"} /></span>
				</>
				}
			</p>
		</div>
	);
};

export default DialActionCard;
